module.exports = __webpack_public_path__ + "img/exten-install-header.58dc699b.png";